<template>
<span v-if="field && field.valueType == 'RANGE'">
  <span v-if="field.minValue">
    {{ $t("fieldMin") }}&nbsp;{{ $n(field.minValue, format) }}
  </span>
  <span v-if="field.maxValue">
    <br>
    {{ $t("fieldMax") }}&nbsp;{{ $n(field.maxValue, format) }}
  </span>
</span>
</template>

<script>
export default {
  name: "PriceField",

  props: [
    "field",
    "format"
  ]
}
</script>
